// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3nfXg","title":"ClientInsurance_title__29ik6","itemText":"ClientInsurance_itemText__1enWb"};